/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-01-17 18:05:58
 * @LastEditors: pj
 * @LastEditTime: 2023-01-29 14:02:01
 */

import Vue from 'vue'
import css from 'swiper/swiper.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
export default () => {
    if (process.browser) {
        Vue.use(VueAwesomeSwiper, { css })
    }
    // Vue.use( VueAwesomeSwiper, { css } )
}
